/**
 * Class-name joiner. Deliberately not `tailwind-merge`: our components own their utility lists and a
 * caller's `className` is appended last, so the cascade (or `!` when a caller really must win) is
 * enough. `tailwind-merge` would add ~7 KB gzip and a second copy of Tailwind's class grammar that
 * has to track every Tailwind release.
 */

/** Anything that may be passed as a class name; nested arrays and falsy values are allowed. */
export type ClassValue = string | false | null | undefined | readonly ClassValue[];

/**
 * Joins class names, dropping falsy values and flattening arrays.
 *
 * @example cx('px-3', isActive && 'bg-brand', className)
 */
export function cx(...values: readonly ClassValue[]): string {
  const parts: string[] = [];
  for (const value of values) {
    if (!value) continue;
    parts.push(typeof value === 'string' ? value : cx(...value));
  }
  return parts.filter(Boolean).join(' ');
}
